import React from "react";
import KonselorControlDummy from "./KonselorControlDummy";

export default function VideoKonselingClose() {
  return (
    <div className="aspect-auto sm:aspect-[9/16]  h-screen bg-secondary-800">
      <div className="absolute top-0 h-full w-full   flex items-center justify-center border-8 border-black blur-3xl"></div>
      <div className="absolute w-[98%] m-1 bottom-1 p-2 bg-secondary-700 rounded-2xl opacity-50">
        <KonselorControlDummy />
      </div>
      <div className="absolute top-0 h-full w-full flex items-center justify-center">
        <div className="text-center">
          <p className="text-white text-lg">Panggilan Video</p>
          <p className="text-white text-lg">Telah Selesai</p>
        </div>
      </div>
    </div>
  );
}
